import { AutogenModelReportScheduleList, AutogenRowReportScheduleList } from "./autogen/AutogenModelReportScheduleList";

export class ModelReportScheduleList extends AutogenModelReportScheduleList<RowReportScheduleList> {
	constructor() {
		super(RowReportScheduleList);
	}
}

export class RowReportScheduleList extends AutogenRowReportScheduleList {
}